// extracted by mini-css-extract-plugin
export var cardLayout = "_8j-1";
export var paginationContainer = "_8j-0";